import React from "react";
import "./TopBar.css";
import { FaEnvelope, FaPhone , FaTwitter, FaFacebookF, FaInstagram, FaLinkedin } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
function TopBar() {
  return (
    <div className="topbar">
      <div className="container">

        <div className="top-left">
          <span><FaEnvelope /> luksmedicus@yahoo.com</span>
          <span><FaPhone /> +389 78 882 223 / +389 78 848 860 / +389 78 447 088</span>
            <span><FaLocationDot /> ул. Козле бр.88/4, Карпош, Скопје</span>
        </div>

        <div className="top-right">
          <FaTwitter />
          <FaFacebookF />
          <FaInstagram />
          <FaLinkedin />
        </div>

      </div>
    </div>
  );
}

export default TopBar;
